import { sendJsonRequest, retrieveJsonRequest } from "./utils";

function makeUrl(siteId) {
    return `/core/feeds/site/${siteId}`;
}

export function getSiteInfo(siteId) {
    return retrieveJsonRequest(makeUrl(siteId), "GET");
}

export function updateSiteInfo(siteId, payload) {
    return sendJsonRequest(makeUrl(siteId), "PUT", { id: siteId, ...payload });
}
